<template>
  <!-- oglasi jedne kategorije (pocetna: Stoka i druge): top kategorija, nisu top oglas ni tezga, bez slike -->
  <AdsBlock
    :items="items"
    :filter="{ top_ad: 0, lawyer: 0, top_category: 1, category_name: category_name }"
    :title="category_name"
    :title-to="{ name: 'oglasi-category-page', params: { category: $srbTolat.srbTolat(category_name), page: 1 } }"
    dropdown="subcategory"
    :show-image="false"
  />
</template>

<script setup>
import AdsBlock from '~/components/widgets/Advertisement/AdsBlock.vue'

const { $srbTolat } = useNuxtApp()

defineProps({
  items: { type: Array, default: () => [] },
  category_name: { type: String, default: '' }
})
</script>
